export const fixationHTML = '<div class="beads_container"><div id="fixation-dot"> </div></div>'
